// Virtual (simulated) drones an operator creates from the UI (issue #322).
// Shape mirrors the backend Drone response for the /api/v1/drones/virtual routes.

export interface VirtualDrone {
  id: string;
  hardware_id: string;
  /** The drone's own name (#406); omitted when it was created without one. */
  name?: string;
  status: string;
  device_model?: string;
  virtual: boolean;
  metadata?: {
    owner_id?: string;
    custom_fields?: Record<string, unknown> | null;
  };
  created_at: string;
}

/** The two images of a virtual drone's simulator (#791). */
export interface SimulatorImages {
  carrier_pigeon: string;
  mavlink_simulator: string;
}

/**
 * What a virtual drone's simulator runs, against the images now pinned, and
 * how its update is going (#791). `running` and `pinned` are absent when no
 * simulator runs, mid-update for one.
 */
export interface VirtualDroneSoftware {
  running?: SimulatorImages;
  pinned?: SimulatorImages;
  update_available: boolean;
  /** An update was cut short after the old simulator stopped: none runs until an update finishes it. */
  update_interrupted: boolean;
  updating: boolean;
  /** The simulator is being switched on (#802). */
  switching_on: boolean;
  /** The last update's or switch-on's failure, until the next change starts. */
  last_failure?: { message: string; at: string };
}

export interface VirtualDroneListResponse {
  drones: VirtualDrone[];
  total: number;
}

/**
 * Pilot-facing display name: the name they gave it, else its id.
 *
 * The drone's own `name` since #406. It used to be read out of
 * `custom_fields`, where the server no longer puts it.
 */
export const virtualDroneName = (d: VirtualDrone): string => d.name ?? d.id;
